/**
 * Randomizer - Simple utility functions for generating random data
 * These utilities use native JavaScript methods without trying to mimic faker.js API
 */

// Random number utilities
export function getRandomInt(min, max) {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min + 1)) + min
}

export function getRandomFloat(min = 0, max = 1, fractionDigits = 2) {
  const randomValue = Math.random() * (max - min) + min
  return Number(randomValue.toFixed(fractionDigits))
}

// Random array/string utilities
export function getRandomItem(array) {
  return array[Math.floor(Math.random() * array.length)]
}

export function getRandomString(length = 8) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return result
}

// Random UUID generator
export function generateUuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

// Random date generators
export function getRandomFutureDate(maxDaysInFuture = 365) {
  const now = new Date()
  const futureDate = new Date(now)
  futureDate.setDate(now.getDate() + getRandomInt(1, maxDaysInFuture))
  return futureDate
}

// Data generation functions
export function generateProductName() {
  const adjectives = ['Small', 'Ergonomic', 'Rustic', 'Intelligent', 'Gorgeous', 'Fantastic']
  const materials = ['Steel', 'Wooden', 'Plastic', 'Cotton', 'Metal', 'Soft']
  const products = ['Chair', 'Computer', 'Keyboard', 'Bike', 'Table', 'Shoes', 'Phone', 'Pizza']

  return `${getRandomItem(adjectives)} ${getRandomItem(materials)} ${getRandomItem(products)}`
}

export function generateCompanyName() {
  const prefixes = ['Acme', 'Globex', 'Initech', 'Umbrella', 'Stark', 'Cyberdyne']
  const suffixes = ['Corp', 'Inc', 'LLC', 'Systems', 'Tech', 'Labs']

  return `${getRandomItem(prefixes)} ${getRandomItem(suffixes)}`
}

export function generateDepartment() {
  const departments = [
    'Books',
    'Electronics',
    'Home',
    'Games',
    'Tools',
    'Health',
    'Beauty',
    'Sports',
    'Automotive',
  ]
  return getRandomItem(departments)
}

export function generateCountryCode() {
  const countryCodes = ['US', 'CA', 'GB', 'DE', 'FR', 'JP', 'CN', 'AU', 'IN']
  return getRandomItem(countryCodes)
}

export function generateUrl() {
  const domains = ['example.com', 'test.org', 'sample.net', 'demo.io']
  const protocols = ['http', 'https']
  const paths = ['home', 'about', 'contact', 'products']

  return `${getRandomItem(protocols)}://${getRandomString(5)}.${getRandomItem(domains)}/${getRandomItem(paths)}`
}

export function generateAvatarUrl() {
  return `https://i.pravatar.cc/150?u=${Math.random()}`
}

export function generateImageUrl() {
  return `https://picsum.photos/seed/${getRandomString(5)}/300/200`
}

export function generateSentence() {
  const words = [
    'lorem',
    'ipsum',
    'dolor',
    'sit',
    'amet',
    'consectetur',
    'adipiscing',
    'elit',
    'sed',
    'tempor',
    'magna',
    'aliqua',
    'enim',
    'minim',
    'veniam',
  ]

  const length = getRandomInt(5, 8)
  let result = ''

  for (let i = 0; i < length; i++) {
    result += `${getRandomItem(words)} `
  }

  return `${result.trim()}.`
}

export function generateParagraph(sentenceCount = 3) {
  let result = ''
  const count = sentenceCount || getRandomInt(2, 4)

  for (let i = 0; i < count; i++) {
    result += `${generateSentence()} `
  }

  return result.trim()
}

export function formatCurrency(amount, decimals = 2) {
  return amount.toFixed(decimals)
}
